"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainContractsHelper_1 = __importDefault(require("./onchainContractsHelper"));
const impermaxFactory_1 = __importDefault(require("./impermaxFactory"));
const onchainLendingVault_1 = __importDefault(require("./onchainLendingVault"));
const account_1 = __importDefault(require("./account"));
const interactions_1 = __importDefault(require("./interactions"));
const configManager_1 = __importDefault(require("./configManager"));
class Onchain {
    constructor(cfg) {
        this.getOffchain = () => this.offchain;
        this.getContractHelper = () => this.contractsHelper;
        this.getConfigManager = () => this.configManager;
        this.network = cfg.network;
        this.offchain = cfg.offchain;
        this.web3 = cfg.web3;
        this.chainId = cfg.chainId;
        this.uiMargin = 1.1;
        this.liquidityBuffer = 0.0001; // always leave 0.01% liquidity to avoid failures due to exchangeRate increase
        this.dust = 1.00000001;
        this.priceInverted = cfg.priceInverted ? cfg.priceInverted : false;
        this.contractsHelper = new onchainContractsHelper_1.default(this);
        this.configManager = new configManager_1.default(this);
        this.factories = {};
        this.accounts = {};
        this.lendingVaults = {};
        this.interactions = {};
    }
    cleanCache() {
        for (const factory in this.factories) {
            this.factories[factory].cleanCache();
        }
        for (const address in this.lendingVaults) {
            this.lendingVaults[address].cleanCache();
        }
        for (const address in this.accounts) {
            this.accounts[address].cleanCache();
        }
        for (const address in this.interactions) {
            this.interactions[address].cleanCache();
        }
    }
    setPriceInverted(priceInverted) {
        this.priceInverted = priceInverted;
    }
    getImpermaxFactory(factory) {
        if (!this.factories[factory])
            this.factories[factory] = new impermaxFactory_1.default(this, factory);
        return this.factories[factory];
    }
    getLendingVault(vaultAddress) {
        if (!this.lendingVaults[vaultAddress])
            this.lendingVaults[vaultAddress] = new onchainLendingVault_1.default(this, vaultAddress);
        return this.lendingVaults[vaultAddress];
    }
    getAccount(address) {
        if (!this.accounts[address])
            this.accounts[address] = new account_1.default(this, address);
        return this.accounts[address];
    }
    getInteractions(address) {
        if (!this.interactions[address])
            this.interactions[address] = new interactions_1.default(this, address);
        return this.interactions[address];
    }
}
exports.default = Onchain;
